<div class="flex flex-col h-full w-full overflow-hidden bg-pmdf-primary">
    <!-- Header: Logo + Nome -->
    <div class="shrink-0 flex flex-row items-center gap-4 pt-4 px-8">
      <img src="/img/logo/logo.svg" alt="Logo PMDF" class="h-10 w-auto shrink-0">
      @if (expanded()) {
        <div class="mt-2 ml-2">
          <span class="text-2xl font-extralight tracking-widest truncate text-pmdf-base-primary">NexusApp</span>
        </div>
        
      }
    </div>
  
    <!-- Navigation -->
    <nav class="flex-1 overflow-y-auto overflow-x-hidden p-2 min-h-0" [class.pb-16]="isMobile()">
      @for (group of navigationGroups(); track group.title) {
        @if (expanded()) {
          <div class="px-3 py-2 mt-4 first:mt-0">
            <span class="text-sm font-bold uppercase tracking-wider text-pmdf-muted-55">
              {{ group.title }}
            </span>
          </div>
        }
        
        @for (item of group.items; track item.label) {
          <app-sidenav-item [item]="item" [expanded]="expanded()" />
        }
        
        @if (!expanded() && !$last) {
          <div class="h-px my-2"></div>
        }
      }
    </nav>
  
    <!-- User Menu -->
    <div class="shrink-0 border-y-2 border-pmdf-border-strong p-2 pb-4" [class.mb-14]="isMobile()">
      <app-sidenav-user-menu [expanded]="expanded()" class="w-full" />
    </div>
  </div>
  
